import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import DownloadModal from "../../Modals/DownloadModal";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  SetSelectdPage,
  SetSizeFilter,
  SetTopSizeFilter,
  SortProducts,
  getAllProductOnline,
  getLastDoc,
} from "../../../features/Products/ProductSlice";
import { Carousel } from "react-bootstrap";
import banner1new from "../../../assets/images/newwebbannerfirstt.webp";
import banner2new from "../../../assets/images/banner2neww.webp";
function BannerMobile() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const { t, i18n } = useTranslation();
  const [index, setIndex] = useState(0);
  const carouselRef = useRef(null);

  // Handle carousel slide selection with smooth behavior
  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  // Navigate to products with smooth scrolling
  const handleNavigate = (url) => {
    navigate(url);
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // Changed from "instant" to "smooth"
    });
  };

  // Set RTL styles if Arabic language is selected
  const arabStyle =
    i18n.language === "ar"
      ? { letterSpacing: "0em", textAlign: "right", borderRadius: "3px" }
      : { borderRadius: "3px" };

  useEffect(() => {
    dispatch(SortProducts(""));
    dispatch(SetSelectdPage(0));
    dispatch(SetSizeFilter([]));
    dispatch(SetTopSizeFilter([]));
    dispatch(getAllProductOnline([]));
    dispatch(getLastDoc(null));
  }, []);

  // The main banner container style with fixed height to prevent layout shift
  const bannerContainerStyle = {
    backgroundColor: "#2A0909",
    height: "406px",
    overflow: "hidden", // Prevents content from causing layout shifts
  };

  // Style for consistent image height
  const bannerImageStyle = {
    width: "100%",
    height: "240px",
    objectFit: "cover",
    display: "block", // Removes any default spacing
  };

  return (
    <>
      {/* for mobile */}
      <div className="d-md-none d-block px-0">
        <div className="show-modal-download">
          {show && <DownloadModal show={show} setShow={setShow} />}
        </div>

        <div className="col-12 px-0">
          <Carousel
            indicators={false}
            controls={false}
            interval={15000} // 15 seconds
            fade={true}
          >
            <Carousel.Item>
              <div className="row g-0" style={bannerContainerStyle}>
                <div className="col-12 p-0">
                  <img
                    src={banner1new}
                    alt="Luxury for less"
                    className="w-100"
                    style={bannerImageStyle}
                  />
                </div>
                <div className="col-12 p-0">
                  <div className="carousel-txt py-3">
                    <div style={{ display: "flex" }}>
                      <p
                        className="carousel-txt-title mb-1"
                        style={{
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                      >
                        {t("Luxuryforless")}
                      </p>
                      <div className="carousel-txt-title-hr"></div>
                    </div>
                    <p
                      className="carousel-txt-subtitle mb-0"
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                      }}
                    >
                      {i18n.language === "ar" ? (
                        <>
                          حقائب خالدة. حيث تلتقي الحقائب الأيقونية بالتسوق
                          الذكي.
                        </>
                      ) : (
                        <>Timeless Bags. Where Iconic Bags Meet Smart Buys.</>
                      )}
                    </p>
                    <p
                      className=""
                      style={{
                        fontSize: "12px",
                        fontWeight: "400",
                        color: "#FFFFFF",
                      }}
                    >
                      {i18n.language === "ar"
                        ? "خصومات تصل إلى 70٪. أصلية 100٪. تم التحقق منها من قبل الخبراء."
                        : "Up to 70% Off. 100% Authentic."}
                    </p>
                    <div
                      onClick={() =>
                        handleNavigate(
                          "/products?topic=pricedrops&id=AqFLulu9y2m4mqEIkch1&"
                        )
                      }
                      className="carousel-btn mt-0"
                      style={arabStyle}
                    >
                      {t("emptybag3")}
                    </div>
                  </div>
                  <div className="custom-indicators-container mb-2">
                    <button
                      className={`custom-indicators ${
                        index === 0 ? "active" : ""
                      }`}
                      onClick={() => handleSelect(0)}
                    ></button>
                    <button
                      className={`custom-indicators ${
                        index === 1 ? "active" : ""
                      }`}
                      onClick={() => handleSelect(1)}
                    ></button>
                  </div>
                </div>
              </div>
            </Carousel.Item>
            <Carousel.Item>
              <div className="row g-0" style={bannerContainerStyle}>
                <div className="col-12 p-0">
                  <img
                    // loading="lazy"
                    // src="/bannertfirstmobile.webp"
                    src={banner2new}
                    alt="Saint Laurent Bags"
                    className="w-100"
                    style={bannerImageStyle}
                  />
                </div>
                <div className="col-12 p-0">
                  <div className="carousel-txt py-3">
                    <div style={{ display: "flex" }}>
                      <p
                        className="carousel-txt-title mb-0"
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        {i18n.language === "ar"
                          ? "حوّل العناصر الفاخرة إلى نقود"
                          : "Turn Luxury Items Into Cash"}
                      </p>
                      <div className="carousel-txt-title-hr"></div>
                    </div>

                    <p
                      style={{
                        fontSize: "16px",
                        fontWeight: "500",
                      }}
                      className="carousel-txt-subtitle mb-0 montserrat-font"
                    >
                      {i18n.language === "ar"
                        ? "احصل على ما يصل إلى 90٪ من قيمتها"
                        : "Unlock up to 90% of its value"}
                    </p>

                    <p
                      style={{
                        fontSize: "12px",
                        fontWeight: "400",
                      }}
                      className="carousel-txt-subtitle mb-0 montserrat-font"
                    >
                      {i18n.language === "ar"
                        ? "إدراج فوري · استلام مجاني · عملية خالية من المتاعب"
                        : "Instant Listing · Free Pickup · Hassle-Free Process"}
                    </p>

                    <div
                      onClick={() => handleNavigate("/how-to-sell")}
                      className="carousel-btn mt-4"
                      style={arabStyle}
                    >
                      {i18n.language === "ar" ? "بيع عنصر" : "Sell an Item"}
                    </div>
                  </div>
                  <div className="custom-indicators-container mb-2">
                    <button
                      className={`custom-indicators ${
                        index === 0 ? "active" : ""
                      }`}
                      onClick={() => handleSelect(0)}
                    ></button>
                    <button
                      className={`custom-indicators ${
                        index === 1 ? "active" : ""
                      }`}
                      onClick={() => handleSelect(1)}
                    ></button>
                  </div>
                </div>
              </div>
            </Carousel.Item>
          </Carousel>
        </div>
      </div>
    </>
  );
}

export default BannerMobile;
